import { useEffect, useState } from 'react';
import ReactPaginate from 'react-paginate';

import { Link } from 'react-router-dom';
import axios from 'axios';
import API_BASE_URL from '../../../constants/api';
interface CourseData {
  course_id: number;
  title: string;
  thumb: string;
  tag: string;
  review: string;
  price: string;
  lesson: string;
  minute: string | null;
  student: number | null;
  desc: string | null;
  language: string | null;
  country: string | null;
  overview?: {
    description: string;
    extraNote: string;
    learnings: string[];
  };
  badges?: string[];
}

interface CoursesApiResponse {
  page: string;
  courses: CourseData[];
}


const CourseArea = () => {

   // const { courses, setCourses } = UseCourses();
   const [courses, setCourses] = useState<CourseData[]>([]);
   const itemsPerPage = 12;
   const [itemOffset, setItemOffset] = useState(0);
   const endOffset = itemOffset + itemsPerPage;
   const currentItems = courses.slice(itemOffset, endOffset);
   const pageCount = Math.ceil(courses.length / itemsPerPage);



   useEffect(() => {
   }, [courses]);



     useEffect(() => {
    const fetchCourses = async () => {
      try {
        const res = await axios.get<CoursesApiResponse>(`${API_BASE_URL}courses/home_1`);
        setCourses(res.data.courses);
      } catch (err) {
        console.error('Error fetching courses:', err);
      }
    };

    fetchCourses();
  }, []); 

  
   const handlePageClick = (event: { selected: number }) => {
      const newOffset = (event.selected * itemsPerPage) % courses.length;
      setItemOffset(newOffset);
   };

   const [activeTab] = useState(0);


   return (
    <section className="all-courses-area section-py-120 " style={{ paddingBottom: '120px' }}>
      <div className="container">
        <div className="row">
          {/* <CourseSidebar setCourses={setCourses} /> */}
          {/* <div className="col-xl-9 col-lg-8"> */}
              <div className="col-xl-12">
            {/* <CourseTop
              startOffset={startOffset}
              endOffset={Math.min(endOffset, totalItems)}
              totalItems={totalItems}
              setCourses={setCourses}
              handleTabClick={handleTabClick}
              activeTab={activeTab}
            /> */}

            <div className="tab-content" id="myTabContent">
              {/* Grid View */}
              <div className={`tab-pane fade ${activeTab === 0 ? 'show active' : ''}`} id="grid" role="tabpanel">
                {/* <div className="row courses__grid-wrap row-cols-1 row-cols-xl-3 row-cols-lg-2 row-cols-md-2 row-cols-sm-1"> */}
                   <div className="row  row-cols-1 row-cols-md-2 row-cols-lg-3 row-cols-xl-4">
                  {currentItems.map((item) => (
                    <div key={item.course_id} className="col">
                      <div className="courses__item shine__animate-item">
                        <div className="">
                        {/* <div className="courses__item-thumb"> */}
                          <Link to={`/course-details/${item.course_id}`} className="shine__animate-link">
                            <img src={item.thumb} alt="img" />
                          </Link>
                        </div>
                        <div className="courses__item-content">
                          <ul className="courses__item-meta list-wrap">
                            <li className="courses__item-tag">
                              <Link to="/course">{item.tag}</Link>
                            </li>
                            <li className="avg-rating"><i className="fas fa-star"></i> {item.review} </li>
                          </ul>
                          <h5 className="title"><Link to={`/course-details/${item.course_id}`}>{item.title}</Link></h5>
                          {/* <p className="author">By <Link to="#">{item.instructors || 'Unknown'}</Link></p> */}
                          <div className="courses__item-bottom">
                            <div className="button">
                              <Link to={`/course-details/${item.course_id}`}>
                                <span className="text">Enroll Now</span>
                                <i className="flaticon-arrow-right"></i>
                              </Link>
                            </div>
                            <h5 className="price">₹{item.price}</h5>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                <nav className="pagination__wrap mt-30">
                  <ReactPaginate
                    breakLabel="..."
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={3}
                    pageCount={pageCount}
                    renderOnZeroPageCount={null}
                    className="list-wrap"
                  />
                </nav>
              </div>

              {/* List View */}
              <div className={`tab-pane fade ${activeTab === 1 ? 'show active' : ''}`} id="list" role="tabpanel">
                <div className="row courses__list-wrap row-cols-1">
                  {currentItems.map((item) => (
                    <div key={item.course_id} className="col">
                      <div className="courses__item courses__item-three shine__animate-item">
                        <div className="courses__item-thumb">
                          <Link to={`/course-details/${item.course_id}`} className="shine__animate-link">
                            <img src={item.thumb} alt="img" />
                          </Link>
                        </div>
                        <div className="courses__item-content">
                          <ul className="courses__item-meta list-wrap">
                            <li className="courses__item-tag">
                              <Link to="/course">{item.tag}</Link>
                              <div className="avg-rating">
                                <i className="fas fa-star"></i>  ({item.review} )
                              </div>
                            </li>
                            <li className="price">₹{item.price}</li>
                          </ul>
                          <h5 className="title"><Link to={`/course-details/${item.course_id}`}>{item.title}</Link></h5>
                          {/* <p className="author">By <Link to="#">{item.instructors || 'Unknown'}</Link></p> */}
                          <p className="info">{item.desc}</p>
                          <div className="courses__item-bottom">
                            <div className="button">
                              <Link to={`/course-details/${item.course_id}`}>
                                <span className="text">Enroll Now</span>
                                <i className="flaticon-arrow-right"></i>
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                <nav className="pagination__wrap mt-30">
                  <ReactPaginate
                    breakLabel="..."
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={3}
                    pageCount={pageCount}
                    renderOnZeroPageCount={null}
                    className="list-wrap"
                  />
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CourseArea;
